// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2de287ff","977":"80ef8d83"}[chunkId] + ".chunk.js";
};